import { Typography } from "antd";

import { BlockContainer } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContainer/BlockContainer";
import { BlockContent } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContent/BlockContent";
import { BlockTitle } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockTitle/BlockTitle";
import {
    getJourneyNodeIcon,
    getJourneyNodeTypeConfig,
} from "Components/elements/RVFlow/Shared/JourneyNodePresentation";
import { NodeType } from "Types/Journey";

import { EightByEightFormItemKeys } from "../../../../Components/JourneyActionsPanel/NodeEditorPanel/Components/_DemoFormItems/constants";
import { useJourneyBlockData } from "../../Shared/Hooks/useJourneyBlockData/useJourneyBlockData";

import type { SharedBlockProps } from "Components/elements/RVFlow/RVFlowTypes";

import styles from "./EightByEightBlock.module.scss";

const BLOCK_TITLE = "Integrations";
const NODE_TITLE = "Create 8x8 Call";
const NODE_PROMPT = "Choose Campaign";

const BLOCK_VARIANT = getJourneyNodeTypeConfig(NodeType.DEMO_EightByEight).variant;
const BLOCK_ICON = getJourneyNodeIcon(NodeType.DEMO_EightByEight);

export function EightByEightBlock({ data, variant }: SharedBlockProps): JSX.Element {
    const { [EightByEightFormItemKeys.campaignName]: campaignName, [EightByEightFormItemKeys.campaignId]: campaignId } =
        data || {};

    const isNodeConfigured = !!campaignName && !!campaignId;

    const preferedNodeName = `${campaignName} (ID#${campaignId})`;

    const { fallBackTitle, isActive, nodeName } = useJourneyBlockData({
        variant,
        isNodeConfigured,
        preferedNodeName,
        blockTitle: BLOCK_TITLE,
        nodeTitle: NODE_TITLE,
        nodePropmpt: NODE_PROMPT,
    });

    return (
        <BlockContainer iconClassName={styles.EightByEightBrand} variant={BLOCK_VARIANT} icon={BLOCK_ICON}>
            <BlockTitle nodeData={data} fallBackDisplay={fallBackTitle}></BlockTitle>

            <BlockContent isActive={isActive}>
                <Typography.Text>{nodeName}</Typography.Text>
            </BlockContent>
        </BlockContainer>
    );
}
